import * as types from './CitiesTypes';

export default function CitiesReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_CITIES:
            return {
                ...state,
                getCities: {
                    ...state.getCities,
                    cities: payload.data,
                    firstCity: payload.first,
                    lastCity: payload.last,
                    nextCities: payload.next,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CITIES_LOADING:
            return {
                ...state,
                getCities: {
                    ...state.getCities,
                    loading: true
                },
            };
        case types.GET_CITIES_ERROR:
            return {
                ...state,
                getCities: {
                    ...state.getCities,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CITIES_BY_ID:
            return {
                ...state,
                getCitiesById: {
                    ...state.getCitiesById,
                    city: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CITIES_BY_ID_LOADING:
            return {
                ...state,
                getCitiesById: {
                    ...state.getCitiesById,
                    loading: true
                },
            };
        case types.GET_CITIES_BY_ID_ERROR:
            return {
                ...state,
                getCitiesById: {
                    ...state.getCitiesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_CITY_PET_POINT:
            return {
                ...state,
                updateCityPetPoint: {
                    ...state.updateCityPetPoint,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_CITY_PET_POINT_LOADING:
            return {
                ...state,
                updateCityPetPoint: {
                    ...state.updateCityPetPoint,
                    loading: true
                },
            };
        case types.UPDATE_CITY_PET_POINT_ERROR:
            return {
                ...state,
                updateCityPetPoint: {
                    ...state.updateCityPetPoint,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_CITY_PET_POINT_RESET_STATE:
            return {
                ...state,
                updateCityPetPoint: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            }
        case types.UPDATE_CURRENCY:
            return {
                ...state,
                updateCurrency: {
                    ...state.updateCurrency,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_CURRENCY_LOADING:
            return {
                ...state,
                updateCurrency: {
                    ...state.updateCurrency,
                    loading: true
                },
            };
        case types.UPDATE_CURRENCY_ERROR:
            return {
                ...state,
                updateCurrency: {
                    ...state.updateCurrency,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_CURRENCY_RESET_STATE:
            return {
                ...state,
                updateCurrency: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            }
        case types.UPDATE_PAYMENT_METHOD:
            return {
                ...state,
                updatePaymentMethod: {
                    ...state.updatePaymentMethod,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_PAYMENT_METHOD_LOADING:
            return {
                ...state,
                updatePaymentMethod: {
                    ...state.updatePaymentMethod,
                    loading: true
                },
            };
        case types.UPDATE_PAYMENT_METHOD_ERROR:
            return {
                ...state,
                updatePaymentMethod: {
                    ...state.updatePaymentMethod,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_PAYMENT_METHOD_RESET_STATE:
            return {
                ...state,
                updatePaymentMethod: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            }
        
        default:
            return state;
    }
}